@if (!formsDisabled) {
    <table
        class="table table-center table-add-row w-100"
        [class.disabled]="formsDisabled"
        [class.table-last-col]="!formsDisabled">
        <tr>
            @if (isAdhesive) {
                <th>Leverantie</th>
            }
            @if (!isAdhesive) {
                <th>Molen</th>

                <th [matTooltip]="'asphalttype' | tt">Type asfalt</th>

                <th [matTooltip]="'asphaltcode' | tt" width="130">Code centrale</th>

                <th class="number-input">Ton</th>

                <th class="number-input">Dikte</th>
            }
            <th class="number-input" width="150">Oppervlakte <small>m2</small></th>
            @if (!isAdhesive) {
                <th class="number-input">Temp. asfalt</th>
            }
            <th class="number-input">Toepassing</th>
            <th class="comment">Opmerking</th>
            @if (!formsDisabled) {
                <th></th>
            }
        </tr>
        @for (planningAsphalt of projectUsedAsphaltList; track planningAsphalt) {
            <tr
                [asphaltMills]="asphaltMills"
                [formsDisabled]="formsDisabled"
                [mainPlanning]="mainPlanning"
                [planningAsphalt]="planningAsphalt"
                [planning]="planning"
                [isAdhesive]="isAdhesive"
                (delete)="removeAsphaltPlanning(planningAsphalt)"
                app-asphalt-used-list-item></tr>
        }
        <tr [hidden]="formsDisabled">
            <td [attr.colspan]="isAdhesive ? 4 : 9">
                <button class="w-100" (click)="addAsphaltPlanning()" color="primary" mat-button>
                    Toevoegen <i class="fas fa-plus"></i>
                </button>
            </td>
            <td></td>
        </tr>
    </table>
}
@if (formsDisabled) {
    <table class="table table-center" [class.print]="print">
        <tr>
            @if (isAdhesive) {
                <th>Leverantie</th>
            }
            @if (!isAdhesive) {
                <th class="max-col-wrap">
                    Toepassing<br />
                    <i>Molen</i>
                </th>

                <th>
                    Type asfalt<br />
                    <i>Code centrale</i>
                </th>

                <th class="number-input tiny-col-wrap">Ton</th>

                <th class="number-input tiny-col-wrap">Dikte</th>
            }
            <th class="number-input small-col-wrap" width="150">Oppervlakte <small>m2</small></th>
            @if (!isAdhesive) {
                <th class="number-input small-col-wrap">Temp. asfalt</th>
            }
            @if (isAdhesive) {
                <th>Toepassing</th>
            }
            <th class="comment">Opmerking</th>
        </tr>
        @for (planningAsphalt of projectUsedAsphaltList; track planningAsphalt) {
            <tr>
                @if (isAdhesive) {
                    <td>{{ planningAsphalt.asphaltname }}</td>
                }
                @if (asphaltMills && !isAdhesive) {
                    <td class="max-col-wrap">
                        {{ planningAsphalt.application | asphaltApplication }}<br />
                        <i>{{ (asphaltMills | byId: planningAsphalt.asphaltmill_id)?.name }}</i>
                    </td>
                }
                @if (!isAdhesive) {
                    <td class="max-col-wrap">
                        {{ planningAsphalt.asphaltname }}<br />
                        <i>{{ planningAsphalt.asphaltcode }}</i>
                    </td>

                    <td class="number-input tiny-col-wrap">{{ planningAsphalt.tons | number: '0.0-2' }}</td>

                    <td class="number-input tiny-col-wrap">{{ planningAsphalt.thickness | number: '0.0-2' }}</td>
                }
                <td class="number-input small-col-wrap">{{ planningAsphalt.surface | number: '0.0-2' }}</td>
                @if (!isAdhesive) {
                    <td class="number-input small-col-wrap">{{ planningAsphalt.temperature | number: '0.0-2' }}</td>
                }
                @if (isAdhesive) {
                    <td class="max-col-wrap">{{ planningAsphalt.application | asphaltApplication }}</td>
                }
                <td class="max-col-wrap">{{ planningAsphalt.comment }}</td>
            </tr>
        }
    </table>
}
